<template>
    <component
        :is="component"
        :context="context"
        :settings="settings"
        :runtime-state="runtimeState"
        v-on="$listeners"
    />
</template>

<script>
import GeneralProductInformationStep from './GeneralProductInformationStep.vue'
import BulkGeneralProductInformationStep from './BulkGeneralProductInformationStep.vue'

export default {
    name: 'GeneralProductInformationStepV2',
    props: {
        context: { type: Object, required: true },
        settings: { type: Object, required: true },
        runtimeState: { type: Object, required: true },
    },
    computed: {
        component() {
            return this.context.mode === 'bulk'
                ? BulkGeneralProductInformationStep
                : GeneralProductInformationStep
        },
    },
}
</script>
